import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

import {
  MenuItem,
  Paper,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { toast } from "react-toastify";
import { createUpdateTestCase } from "../../../api/projects";
import { USER_DATA } from "../../../utils/constants";
import { TestCaseTypes } from "../../../interfaces/TestCaseTypes";
import Input from "../../../components/Input";
import ButtonLoading from "../../../components/ButtonLoading";
import { SuiteTypes } from "../../../interfaces/SuiteTypes";
import { ActionTypeEnum } from "../../../interfaces/HistoryTypes";
import { mountHistory } from "../../../utils/history";
import { createHistory } from "../../../api/history";
const xls = require("../../../assets/xls.png");

interface DialogImportTestCasesProps {
  open: boolean;
  close: () => void;
  suites: any;
  projectId: any;
  reload: () => void;
}

export default function DialogImportTestCases({
  close,
  open,
  suites,
  projectId,
  reload,
}: DialogImportTestCasesProps) {
  const [testCases, setTestCases] = React.useState<TestCaseTypes[]>([]);
  const [loading, setLoading] = React.useState(false);

  const handleClose = () => {
    close();
  };

  const readDocument = (event: any) => {
    const data: any = [];

    const fileUploaded = event.target.files[0];

    var reader = new FileReader();

    try {
      reader.onload = (e: any) => {
        let lines = e.target.result.split("\r\n");

        console.log(lines);

        let header = lines[0];

        if (
          header !==
          "TITULO;DESCRICAO;PRE CONDICAO;PASSOS;OUTRAS INFORMACOES;RESULTADO;PRIORIDADE"
        ) {
          toast.error(
            "Arquivo não está no padrão, baixe o template preencha as informações e tente novamente"
          );
          setLoading(false);
          return;
        }

        for (let i = 1; i < lines.length; i++) {
          let columns = lines[i].split(";");
          const testCase = {
            title: columns[0],
            description: columns[1],
            pre_conditions: columns[2],
            steps: columns[3].replaceAll('"', ""),
            others_info: columns[4],
            expected_result: columns[5],
            priority: getPriority(columns[6]).value,
            priorityText: getPriority(columns[6]).text,
            suite: "",
            id: new Date().getTime() + i,
            ok: null,
          };

          data.push(testCase);
        }

        setTestCases(data);
      };
    } catch (e) {}
    reader.readAsText(fileUploaded);
  };

  const getPriority = (priority: any) => {
    switch (priority) {
      case "Baixa":
        return { text: "Baixa", value: "LOW" };
      case "Media":
        return { text: "Média", value: "MEDIUM" };
      case "Alta":
        return { text: "Alta", value: "HIGH" };
      default:
        return { text: "", value: "" };
    }
  };

  const checkData = () => {
    var testCaseChanged = testCases;

    for (let index = 0; index < testCases.length; index++) {
      if (
        !testCases[index].suite ||
        testCases[index].suite === "" ||
        testCases[index].title == null ||
        testCases[index].title === "" ||
        testCases[index].description == null ||
        testCases[index].description === "" ||
        testCases[index].pre_conditions == null ||
        testCases[index].pre_conditions === "" ||
        testCases[index].steps == null ||
        testCases[index].steps === "" ||
        testCases[index].expected_result == null ||
        testCases[index].expected_result === "" ||
        testCases[index].priority == null ||
        testCases[index].priority === ""
      ) {
        testCaseChanged[index].ok = false;
      } else {
        testCaseChanged[index].ok = true;
      }
    }
    setTestCases([...testCaseChanged]);
  };

  const changeSuite = (index: number, suite: any) => {
    var testCaseChanged = testCases;
    testCaseChanged[index].suite = suite;

    setTestCases([...testCaseChanged]);
    checkData();
  };

  const hasInfo = (info: any) => {
    if (info) {
      return "#E7FFE7FF";
    } else {
      return "#FFDADAFF";
    }
  };

  const importTestCases = () => {
    setLoading(true);
    if (!verifyTestCases()) {
      toast.error("Existem dados incorretos. Verifique os casos de testes!");
      setLoading(false);
    } else {
      const user_uuid = JSON.parse(localStorage.getItem(USER_DATA) || "{}").uid;

      createUpdateTestCase(
        user_uuid,
        projectId,
        Number(testCases[0].suite),
        testCases,
        ""
      )
        .then((response) => {
          toast.success("Caso de teste adicionado com sucesso");
          createHistory(
            mountHistory(
              projectId,
              ActionTypeEnum.IMPORT,
              `Importação de ${testCases.length} cenários`
            )
          );
          reload();
          close();
          setTestCases([]);
        })
        .catch((e) => {
          console.log(e);
          toast.error("Ocorreu um problema, tente mais tarde!!!!");
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const verifyTestCases = () => {
    for (let index = 0; index < testCases.length; index++) {
      if (!testCases[index].ok) {
        return false;
      }
    }

    return true;
  };

  return (
    <Dialog open={open} onClose={close} fullScreen style={{ margin: 50 }}>
      <DialogTitle>Importar casos de testes</DialogTitle>

      <DialogContent>
        <Stack direction="row" alignContent="center">
          <a
            href="https://firebasestorage.googleapis.com/v0/b/qazando-github-actions.firebasestorage.app/o/qazando-tool%2Fcenarios.csv?alt=media&token=1cf710c0-43e3-4886-a27c-fc7fa5de0914"
            target="_blank"
            rel="noreferrer"
            style={{
              color: "#21A265",
              fontWeight: "500",
              fontSize: "14px",
              lineHeight: "24px",
              textAlign: "right",
            }}
          >
            Download template
          </a>
          <img src={xls} height={24} width={40} alt="CSV" />
        </Stack>

        <Input type="file" onChange={readDocument} />

        <TableContainer component={Paper} sx={{ mt: 6 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align="left">Titulo</TableCell>
                <TableCell align="left">Descrição</TableCell>
                <TableCell align="left">Pré condição</TableCell>
                <TableCell align="left">Passos</TableCell>
                <TableCell align="left">Outras Informações</TableCell>
                <TableCell align="left">Resultado</TableCell>
                <TableCell align="left">Prioridade</TableCell>
                <TableCell align="left">Suite</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {testCases &&
                testCases.map((testCase: TestCaseTypes, index) => (
                  <TableRow key={testCase.title}>
                    <TableCell
                      style={{ backgroundColor: hasInfo(testCase.title) }}
                      align="left"
                    >
                      {" "}
                      {testCase.title}
                    </TableCell>
                    <TableCell
                      style={{ backgroundColor: hasInfo(testCase.description) }}
                      align="left"
                    >
                      {testCase.description}
                    </TableCell>
                    <TableCell
                      style={{
                        backgroundColor: hasInfo(testCase.pre_conditions),
                      }}
                      align="left"
                    >
                      {testCase.pre_conditions}
                    </TableCell>
                    <TableCell
                      style={{
                        backgroundColor: hasInfo(testCase.steps),
                        whiteSpace: "pre-line",
                      }}
                      align="left"
                    >
                      {testCase.steps}
                    </TableCell>
                    <TableCell
                      style={{ backgroundColor: hasInfo("testCase.") }}
                      align="left"
                    >
                      {testCase.others_info}
                    </TableCell>
                    <TableCell
                      style={{
                        backgroundColor: hasInfo(testCase.expected_result),
                      }}
                      align="left"
                    >
                      {testCase.expected_result}
                    </TableCell>
                    <TableCell
                      style={{ backgroundColor: hasInfo(testCase.priority) }}
                      align="left"
                    >
                      {testCase.priorityText}
                    </TableCell>
                    <TableCell
                      style={{ backgroundColor: hasInfo(testCase.suite) }}
                      align="left"
                      width={200}
                    >
                      <Select
                        value={testCase.suite}
                        onChange={(e) => changeSuite(index, e.target.value)}
                        displayEmpty
                        style={{ width: "100%" }}
                      >
                        <MenuItem value="">
                          <em>Suite</em>
                        </MenuItem>
                        {suites.map((suite: SuiteTypes) => (
                          <MenuItem value={suite.id}>{suite.title}</MenuItem>
                        ))}
                      </Select>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      <DialogActions style={{ paddingRight: "20px" }}>
        <ButtonLoading
          loading={loading}
          onClick={handleClose}
          label="Cancelar"
          isDelete
        />
        <ButtonLoading
          loading={loading}
          onClick={importTestCases}
          label="Importar"
        />
      </DialogActions>
    </Dialog>
  );
}
